import React, { useEffect, useState } from "react";
import "./HomeSocialMedia.css";
import axios from "axios";
import { END_URL } from "../../config";
import youtub_link from "../../images/youtube_icon.svg";

function HomeSocialMedia() {

    const [data, setData] = useState(null);


    // useEffect(() => {
    //     const fetchFooterData = async () => {
    //         try {
    //             const res = await axios.get(`${END_URL}/home-footer`);
    //             const homeData = res.data.data?.[0] || null;
    //             setData(homeData);
    //         } catch (error) {
    //             console.error("Error fetching footer data:", error);
    //         }
    //     };
    //     fetchFooterData();
    // }, []);



  return (
    <div className="home-sos">
      <div className="container">
        <div className="row">
          <div className="home-sos-iconDiv">
              <div className="footer-icons">
                    <ul>
                        {data?.links && <li><a href={data?.links} target="_blank" rel="noopener noreferrer" ><i className="fab fa-facebook-f"></i></a></li>}
                        {data?.xlink && <li><a href={data?.xlink} target="_blank" rel="noopener noreferrer" ><i className="fa-brands fa-x-twitter"></i></a></li>}
                        {data?.instalink && <li><a href={data?.instalink} target="_blank" rel="noopener noreferrer" ><i className="fab fa-instagram"></i></a></li>}
                        {data?.youtub_link && <li><a href={data?.youtub_link} target="_blank" rel="noopener noreferrer" ><i class="fab fa-youtube-square"></i></a></li>}

                        
                    </ul>
                </div>
          </div>
        </div>
      </div>
 
    </div>
  );
}

export default HomeSocialMedia;
